import React, { useEffect, useState } from "react";
import { Modal, Box, Button, Stack, } from "@mui/material";
import { colors } from "../common/colors";
import { T } from "react-translator-component";

interface ErrorMessageModalProps {
  open: boolean;
  showButton?: boolean;
  messages: string[];
  onClose: () => void;
  alignLeft?: boolean;
}

export const ErrorMessageModal: React.FC<ErrorMessageModalProps> = ({
  open,
  onClose,
  showButton = true,
  messages,
  alignLeft
}) => {

  const [errorMessage, setErrorMessage] = useState<string[]>([])

  useEffect(() => {
    const messageList: string[] = []
    messages.forEach((message: string) => {
      if (message.includes("\n")) {
        message.split("\n").forEach((sentence: string) => {
          messageList.push(sentence)
        })
      } else {
        messageList.push(message)
      }
    })
    setErrorMessage(messageList)
  }, [messages])

  useEffect(() => {
    let timer: NodeJS.Timeout;

    if (open && !showButton) {
      timer = setTimeout(() => {
        onClose();
      }, 2500);
    }

    return () => clearTimeout(timer);
  }, [open, showButton, onClose]);

  const containerStyle = () => {
    if (showButton) {
      return alignLeft ?
        {...styles.container, textAlign: "left"} :
        {...styles.container, textAlign: "center"}
    } else {
      return alignLeft ?
        {...styles.btnLessContainer, textAlign: "left"} :
        {...styles.btnLessContainer, textAlign: "center"}
    }
  }

  return (
    <Modal sx={styles.modal} open={open} onClose={onClose}>
      <Box sx={containerStyle}>
        {errorMessage.map((message: string, index: number) => (
          <p style={styles.errorMessage} key={`api_error_${index}`}>
            {message}
          </p>
        ))}

        {showButton && (
          <Stack sx={styles.modalButtonContainer}>
            <Button
              onClick={onClose}
              style={styles.dialogButton}
              size={"large"}
              variant="outlined"
            >
              {T('close')}
            </Button>
          </Stack>
        )}
      </Box>
    </Modal>
  );
};

const styles = {
  modal: {
    zIndex: 9999,
  },

  container: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "85%",
    maxWidth: "320px",
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
    padding: "50px 15px 20px 15px",
    borderRadius: "15px",
  },

  btnLessContainer: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "85%",
    maxWidth: "320px",
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
    padding: "50px 15px",
    borderRadius: "15px",
  },

  errorMessage: {
    margin: 0,
    fontFamily: "mplus-1c-regular"
  },

  modalButtonContainer: {
    alignItems: "center",
    justifyContent: "center",
    marginTop: "30px"
  },

  dialogButton: {
    width: "50%",
    minWitdh: "100px",
    alignSelf: "center",
    display: "flex",
    border: "3px solid",
    borderRadius: "10px",
    borderColor: colors.farm_blue200,
    color: colors.farm_black
  }
}
